// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* it don't matter if you're black or white... */
/* DEPRECATED: need to update theme to use \$brand-palette instead of this */
.success {
  color: #4caf50;
}

.error {
  color: #f44336;
}

.brand {
  color: #004a7c;
}

.brand-shade {
  color: #003254;
}

.gray {
  color: #777;
}

.gray-shade {
  color: #373737;
}

.success-inv {
  background-color: #4caf50;
  color: white;
}

.error-inv {
  background-color: #f44336;
  color: white;
}

.gray-shade-inv {
  background-color: #373737;
  color: white;
}

.gray-light-tint-back {
  background-color: #f7f7f7;
}

.buttonWidth {
  width: 100%;
  height: 50px;
  background-color: transparent;
}

.mat-mdc-button {
  min-width: 64px !important;
  margin-right: 9px !important;
}

.buttonWidth.mdc-button {
  background-color: #004a7c;
}

.mat-toolbar {
  height: 50px;
  overflow: hidden;
  position: relative;
}
.mat-toolbar .toolbar-wrapper {
  height: 100%;
  margin: 0 auto;
  max-width: 1280px;
  width: 100%;
}
.mat-toolbar .brand-logo {
  display: block;
  height: 100%;
  width: 400px;
}
.mat-toolbar .brand-logo.logo {
  background-image: url("/assets/logo.png");
  background-position: left;
  background-size: contain;
  background-repeat: no-repeat;
}
.mat-toolbar .brand-logo.dragonboat {
  height: 140%;
  background-image: url("/assets/dragonboat.png");
  background-position: left top;
  background-size: 66%;
  background-repeat: no-repeat;
}
.mat-toolbar .brand-logo.dragonboat:after {
  animation: drift 15000ms infinite cubic-bezier(0.25, 0.5, 0.7, 0.35);
  background-image: url('data:image/svg+xml;utf8,<svg height="25px" width="100px" xmlns="http://www.w3.org/2000/svg"><path fill="#a6e0f7" opacity="0.6" d="M0 30 V15 Q30 3 60 15 V30z" /><path fill="#a6e0f7" d="M0 30 V12 Q30 17 55 10 T100 11.5 V30z" /></svg>');
  background-position: left 120%;
  background-repeat: repeat-x;
  content: "";
  height: 50px;
  left: 0;
  opacity: 0.9;
  position: absolute;
  top: 0;
  transform: translate(-600px) skewX(65deg);
  width: 10000px;
}
@keyframes drift {
  from {
    transform: translate(-100px) skewX(65deg);
  }
}
.mat-toolbar .fill-remaining-space {
  font-size: 0.5em;
  flex: 1 1 auto;
}
.mat-toolbar .menu-item {
  font-size: 16px;
  font-weight: 300;
  padding: 0 15px;
}
.mat-toolbar .menu-item .mat-icon {
  font-size: 18px;
  padding-left: 4px;
  position: relative;
  top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/theme/colors.scss","webpack://./src/app/shared/components/header/header.component.scss"],"names":[],"mappings":"AAAA,gDAAA;AA8GA,2EAAA;AAcA;EACE,cA5FQ;AC7BV;;AD4HA;EACE,cApEM;ACrDR;;AD4HA;EACE,cAhIM;ACOR;;AD4HA;EACE,cAnIY;ACUd;;AD4HA;EACE,WAjEK;ACxDP;;AD4HA;EACE,cAnEW;ACtDb;;AD4HA;EACE,yBApHQ;EAqHR,YAAA;ACzHF;;AD4HA;EACE,yBA7FM;EA8FN,YAAA;ACzHF;;AD4HA;EACE,yBAjFW;EAkFX,YAAA;ACzHF;;AD4HA;EACE,yBAxEgB;ACjDlB;;AAzCA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;AA4CF;;AAzCA;EACE,0BAAA;EACA,4BAAA;AA4CF;;AA1CA;EACA,yBAAA;AA6CA;;AA1CA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AA6CF;AA3CE;EACE,YAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;AA6CJ;AA1CE;EACE,cAAA;EACA,YAAA;EACA,YAAA;AA4CJ;AA1CI;EACE,yCAAA;EACA,yBAAA;EACA,wBAAA;EACA,4BAAA;AA4CN;AAzCI;EACE,YAAA;EACA,+CAAA;EACA,6BAAA;EACA,oBAAA;EACA,4BAAA;AA2CN;AAzCM;EAOE,oEAAA;EACA,gQAAA;EACA,8BAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,yCAAA;EACA,cAAA;AAqCR;AAtDQ;EACE;IACE,yCAAA;EAwDV;AACF;AArCE;EACE,gBAAA;EACA,cAAA;AAuCJ;AApCE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAsCJ;AApCI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAsCN","sourcesContent":["/* it don't matter if you're black or white... */\n$black: #000;\n$white: #fff;\n\n$brand-tint: #1890e2;\n$brand: #004a7c;\n$brand-shade: #003254;\n$brand-palette: (\n  300: $brand-tint,\n  400: $brand,\n  500: $brand-shade,\n  contrast: (\n    300: $black,\n    400: $white,\n    500: $white,\n  ),\n);\n\n$brand-light-tint: #a6e0f7;\n$brand-light: #00adef;\n$brand-light-shade: #006e98;\n$brand-light-palette: (\n  300: $brand-light-tint,\n  400: $brand-light,\n  500: $brand-light-shade,\n  contrast: (\n    300: $black,\n    400: $white,\n    500: $white,\n  ),\n);\n\n$success-tint: #c8e6c9;\n$success: #4caf50;\n$success-shade: #2e7d32;\n$success-palette: (\n  300: $success-tint,\n  400: $success,\n  500: $success-shade,\n  contrast: (\n    300: $black,\n    400: $white,\n    500: $white,\n  ),\n);\n\n$warning-tint: #ffc107;\n$warning: #ffe082;\n$warning-shade: #ff8f00;\n$warning-palette: (\n  300: $warning-tint,\n  400: $warning,\n  500: $warning-shade,\n  contrast: (\n    300: $black,\n    400: $white,\n    500: $white,\n  ),\n);\n\n$error-tint: #ffcdd2;\n$error: #f44336;\n$error-shade: #c62828;\n$error-palette: (\n  300: $error-tint,\n  400: $error,\n  500: $error-shade,\n  contrast: (\n    300: $black,\n    400: $white,\n    500: $white,\n  ),\n);\n\n$gray-tint: #c7c8ca;\n$grey-tint: $gray-tint;\n$gray: #777;\n$grey: $gray;\n$gray-shade: #373737;\n$grey-shade: $gray-shade;\n$gray-palette: (\n  300: $gray-tint,\n  400: $gray,\n  500: $gray-shade,\n  contrast: (\n    300: $black,\n    400: $white,\n    500: $white,\n  ),\n);\n$grey-palette: $gray-palette;\n\n$gray-light-tint: #f7f7f7;\n$grey-light-tint: $gray-light-tint;\n$gray-light: #e0e0e0;\n$grey-light: $gray-light;\n$gray-light-shade: #c4c4c4;\n$grey-light-shade: $gray-light-shade;\n$gray-light-palette: (\n  300: $gray-light-tint,\n  400: $gray-light,\n  500: $gray-light-shade,\n  contrast: (\n    300: $black,\n    400: $black,\n    500: $black,\n  ),\n);\n$grey-light-palette: $gray-light-palette;\n\n/* DEPRECATED: need to update theme to use $brand-palette instead of this */\n$rs-blue-pal: (\n  300: $brand-light,\n  400: $brand-tint,\n  500: $brand,\n  600: $brand-shade,\n  contrast: (\n    300: $white,\n    400: $black,\n    500: $white,\n    600: $white,\n  ),\n);\n\n.success {\n  color: $success;\n}\n\n.error {\n  color: $error;\n}\n\n.brand {\n  color: $brand;\n}\n\n.brand-shade {\n  color: $brand-shade;\n}\n\n.gray {\n  color: $gray;\n}\n\n.gray-shade {\n  color: $gray-shade;\n}\n\n.success-inv {\n  background-color: $success;\n  color: white;\n}\n\n.error-inv {\n  background-color: $error;\n  color: white;\n}\n\n.gray-shade-inv {\n  background-color: $gray-shade;\n  color: white;\n}\n\n.gray-light-tint-back {\n  background-color: $gray-light-tint;\n}\n","@import \"../../../../theme/colors.scss\";\n\n.buttonWidth {\n  width: 100%;\n  height: 50px;\n  background-color: transparent;\n}\n\n.mat-mdc-button {\n  min-width: 64px !important;\n  margin-right: 9px !important;\n}\n.buttonWidth.mdc-button{\nbackground-color: #004a7c;\n}\n\n.mat-toolbar {\n  height: 50px;\n  overflow: hidden;\n  position: relative;\n\n  .toolbar-wrapper {\n    height: 100%;\n    margin: 0 auto;\n    max-width: 1280px;\n    width: 100%;\n  }\n\n  .brand-logo {\n    display: block;\n    height: 100%;\n    width: 400px;\n\n    &.logo {\n      background-image: url(\"/assets/logo.png\");\n      background-position: left;\n      background-size: contain;\n      background-repeat: no-repeat;\n    }\n\n    &.dragonboat {\n      height: 140%;\n      background-image: url(\"/assets/dragonboat.png\");\n      background-position: left top;\n      background-size: 66%;\n      background-repeat: no-repeat;\n\n      &:after {\n        @keyframes drift {\n          from {\n            transform: translate(-100px) skewX(65deg);\n          }\n        }\n\n        animation: drift 15000ms infinite cubic-bezier(0.25, 0.5, 0.7, 0.35);\n        background-image: url('data:image/svg+xml;utf8,<svg height=\"25px\" width=\"100px\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#{$brand-light-tint}\" opacity=\"0.6\" d=\"M0 30 V15 Q30 3 60 15 V30z\" /><path fill=\"#{$brand-light-tint}\" d=\"M0 30 V12 Q30 17 55 10 T100 11.5 V30z\" /></svg>');\n        background-position: left 120%;\n        background-repeat: repeat-x;\n        content: \"\";\n        height: 50px;\n        left: 0;\n        opacity: 0.9;\n        position: absolute;\n        top: 0;\n        transform: translate(-600px) skewX(65deg);\n        width: 10000px;\n      }\n    }\n  }\n\n  .fill-remaining-space {\n    font-size: 0.5em;\n    flex: 1 1 auto;\n  }\n\n  .menu-item {\n    font-size: 16px;\n    font-weight: 300;\n    padding: 0 15px;\n\n    .mat-icon {\n      font-size: 18px;\n      padding-left: 4px;\n      position: relative;\n      top: 4px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
